import { toApiDate } from "@marekl/adminer/datetime";
import { formatDate } from "@marekl/adminer/format";
import { emptyPerson, type DraftPerson } from "./draftTypes";

/** The person fields of a draft row, how they compare and how they read. */

export const FIELDS = Object.keys(emptyPerson) as (keyof DraftPerson)[];

export const FIELD_LABELS: Record<keyof DraftPerson, string> = {
  first_name: "Jméno",
  last_name: "Příjmení",
  country_code: "Státní příslušnost",
  birth_date: "Datum narození",
  birth_number: "Rodné číslo",
  street: "Ulice a číslo popisné",
  city: "Město",
  postal_code: "PSČ",
  phone: "Telefon",
};

/** A field's value as the comparison sees it: what the server would store. */
export function norm(field: keyof DraftPerson, v: DraftPerson[keyof DraftPerson]): string {
  if (field === "birth_date") return toApiDate(v as DraftPerson["birth_date"]) ?? "";
  const s = String(v ?? "").trim();
  return field === "country_code" ? (s || "CZ").toUpperCase() : s;
}

/** How a value reads in a sentence: „prázdné" for nothing at all. */
export function displayValue(field: keyof DraftPerson, v: DraftPerson[keyof DraftPerson]): string {
  if (field === "birth_date") {
    const d = v as DraftPerson["birth_date"];
    return d ? formatDate(d) : "prázdné";
  }
  return String(v ?? "").trim() || "prázdné";
}

